<div class="card-header">
  <app-breadcrumb currentPage="tweede bewindvoerder toevoegen"></app-breadcrumb>
</div>
<div class="card-body">
  <p class="mb28">Vul de gegevens van de tweede bewindvoerder in</p>
  <h2>1. logingegevens</h2>
  <form (ngSubmit)="submit(form.value)" [formGroup]="form" class="form">

    <!-- username -->
    <div [ngClass]="{ 'input-error': submitted && f.username.errors }">
      <label for="defaultLoginFormEmail" class="form-label">{{'email_address' | translate}}</label>
      <input (input)="checkForEmail($event)" formControlName="username" id="defaultLoginFormEmail" type="email">
      <div class="errors">
        <div *ngIf="f.username.errors?.required">{{'email_address.required' | translate}}</div>
        <div *ngIf="f.username.errors?.pattern">{{'email_address.invalid' | translate}}</div>
        <div *ngIf="f.username.errors?.maxlength">{{'email_address.maxLength' | translate}}</div>
      </div>
      <div *ngIf="!usernameAvailable">e-mailadres is al in gebruik</div>
    </div>
    <label class="form-label unselectable" for="showEmailOnReports">
      <input formControlName="showEmailOnReports" id="showEmailOnReports" placeholder="YYYY" type="checkbox">
      <span class="pl12">e-mailadres mag worden getoond in de rapportage</span>
    </label>

    <div class="spacer-large"></div>
    <h2>2. persoonsgegevens</h2>
    <p>deze worden gebruikt voor het genereren van de rapportages</p>

    <!-- firstNameInitials -->
    <div [ngClass]="{ 'input-error': submitted && f.firstNameInitials.errors }">
      <label for="firstNameInitials" class="form-label">{{'name.first_name_initials' | translate}}</label>
      <input formControlName="firstNameInitials" id="firstNameInitials" type="text">
      <div class="errors">
        <div *ngIf="f.firstNameInitials.errors?.required"> {{'name.first_name_initials.required' | translate}}</div>
        <div *ngIf="f.firstNameInitials.errors?.maxlength">{{'name.first_name_initials.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- firstName -->
    <div [ngClass]="{ 'input-error': submitted && f.firstName.errors }">
      <label for="firstName" class="form-label">{{'name.first_name' | translate}}</label>
      <input formControlName="firstName" id="firstName" type="text">
      <div class="errors">
        <div *ngIf="f.firstName.errors?.required"> {{'name.first_name.required' | translate}}</div>
        <div *ngIf="f.firstName.errors?.maxlength">{{'name.first_name.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- insertion -->
    <div [ngClass]="{ 'input-error': submitted && f.insertion.errors }">
      <label for="insertion" class="form-label">{{'name.insertion' | translate}}</label>
      <input formControlName="insertion" id="insertion" type="text">
      <div class="errors">
        <div *ngIf="f.insertion.errors?.maxlength">{{'name.insertion.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- lastName -->
    <div [ngClass]="{ 'input-error': submitted && f.lastName.errors }">
      <label for="lastName" class="form-label">{{'name.last_name' | translate}}</label>
      <input formControlName="lastName" id="lastName" type="text">
      <div class="errors">
        <div *ngIf="f.lastName.errors?.required">{{'name.last_name.required' | translate}}</div>
        <div *ngIf="f.lastName.errors?.maxlength">{{'name.last_name.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- phone-->
    <div [ngClass]="{ 'input-error': submitted && f.phone.errors }">
      <label for="phone" class="form-label">{{'phone' | translate}}</label>
      <input formControlName="phone" id="phone" type="text">
      <div class="errors">
        <div *ngIf="f.phone.errors?.required">{{'phone.required' | translate}}</div>
        <div *ngIf="f.phone.errors?.maxlength">{{'phone.last_name.maxLength' | translate}}</div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <h2>3. adresgegevens</h2>
    <!-- street -->
    <div [ngClass]="{ 'input-error': submitted && f.street.errors }">
      <label for="street" class="form-label">{{'address.street' | translate}}</label>
      <input formControlName="street" id="street" type="text">
      <div class="errors">
        <div *ngIf="f.street.errors?.required">{{'address.street.required' | translate}}</div>
        <div *ngIf="f.street.errors?.maxlength">{{'address.street.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- houseNumber -->
    <div [ngClass]="{ 'input-error': submitted && f.houseNumber.errors }">
      <label for="houseNumber" class="form-label">{{'address.house_number' | translate}}</label>
      <input formControlName="houseNumber" id="houseNumber" type="text">
      <div class="errors">
        <div *ngIf="f.houseNumber.errors?.required">{{'address.house_number.required' | translate}}</div>
        <div *ngIf="f.houseNumber.errors?.maxlength">{{'address.house_number.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- houseNumberSuffix -->
    <div [ngClass]="{ 'input-error': submitted && f.houseNumberSuffix.errors }">
      <label for="houseNumberSuffix" class="form-label">{{'address.house_number_suffix' | translate}}</label>
      <input formControlName="houseNumberSuffix" id="houseNumberSuffix" type="text">
      <div class="errors">
        <div *ngIf="f.houseNumberSuffix.errors?.required">{{'address.house_number_suffix.required' | translate}}</div>
        <div *ngIf="f.houseNumberSuffix.errors?.maxlength">{{'address.house_number_suffix.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- zipCode -->
    <div [ngClass]="{ 'input-error': submitted && f.zipCode.errors }">
      <label for="zipCode" class="form-label">{{'address.zip_code' | translate}}</label>
      <input formControlName="zipCode" id="zipCode" type="text">
      <div class="errors">
        <div *ngIf="f.zipCode.errors?.required">{{'address.zip_code.required' | translate}}</div>
        <div *ngIf="f.zipCode.errors?.maxlength">{{'address.zip_code.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- city -->
    <div [ngClass]="{ 'input-error': submitted && f.city.errors }">
      <label for="city" class="form-label">{{'address.city' | translate}}</label>
      <input formControlName="city" id="city" type="text">
      <div class="errors">
        <div *ngIf="f.city.errors?.required">{{'address.city.required' | translate}}</div>
        <div *ngIf="f.city.errors?.maxlength">{{'address.city.maxLength' | translate}}</div>
      </div>
    </div>

    <div class="spacer-large"></div>

    <button routerLink="/" class="btn btn-left arrow-left">deze stap overslaan</button>
    <button *ngIf="!isLoading" class="btn check inverted accent" type="submit">registreer bewindvoerder</button>
  </form>
</div>
